import React, { useContext, useMemo } from 'react'
import classes from './NoAccess.module.css'
import { isMobile } from '../../Constants'
import { MyCompanyProfileContext } from '../../MyCompanyProfileContext'
import { UserApiContext } from '../UserDetailsContext/UserDetailsContext'

const NoAccess = (show) => {
    const { companySettingData } = useContext(MyCompanyProfileContext) || {};
    const { userDetails } = useContext(UserApiContext)
    const isSuperAdmin = useMemo(() => {
        if (companySettingData && companySettingData.contact_information) {
            const email = userDetails?.email?.toLowerCase();
            if (email) {
                const user = companySettingData.contact_information.find(
                    u => u.email?.toLowerCase() === email
                );
                if (user) {
                    return user.super_admin === true;
                }
            }
        }
        return false;
    }, [companySettingData]);

    const message = isSuperAdmin
        ? "You are a Super Admin, but you currently do not have permission to access this section. Please contact the system administrator to update your access rights."
        : "You are currently not a designated Super User, please request the current Super User to add you to the designated Super User List";

    return (
        <div>
            {!show !== true ? (
                <div className="container">
                    {!isMobile() ? (
                        <div className={classes['box_noaccess']}>
                            <span>{message}</span>
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', flex: '100%', height: '10vh', marginTop: '12%', backgroundColor: 'white', marginBottom: '3%', padding: '1%', boxShadow: '2px 2px 10px slategrey' }}>
                            <span>{message}</span>
                        </div>
                    )}
                </div>
            ) : null}
        </div>
    )
}

export default NoAccess
